import React from 'react';
import PropTypes from 'prop-types';

import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import { withStyles } from '@material-ui/core/styles';
import FormHelperText from '@material-ui/core/FormHelperText';

import styles from './styles';

const propTypes = {
  input: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func,
  }).isRequired,
  meta: PropTypes.shape({
    error: PropTypes.string,
    touched: PropTypes.bool,
    invalid: PropTypes.bool,
  }).isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  error: PropTypes.string,
  touched: PropTypes.bool,
  children: PropTypes.arrayOf(PropTypes.any).isRequired,
  classes: PropTypes.object.isRequired,
  onChange: PropTypes.func,
  onSelectChange: PropTypes.func,
  enableEditing: PropTypes.any,
};

const defaultProps = {
  onSelectChange: () => {},
};

const renderFromHelper = ({ touched, error }) => {
  if (touched && error) {
    return <FormHelperText>{touched && error}</FormHelperText>;
  }
  return null;
};

export const SelectFormField = props => {
  const {
    input: { onChange, value },
    label,
    name,
    id,
    classes,
    meta: { error, touched },
    children,
    onSelectChange,
    enableEditing,
    ...otherProps
  } = props;

  const handleChange = event => {
    onChange(event);
    onSelectChange(event.target.value);
  };

  return (
    <FormControl
      error={touched && error}
      className={classes.selectFormControlStyle}
    >
      <InputLabel classes={classes}>{label}</InputLabel>
      <Select
        native
        value={value}
        disabled={enableEditing}
        onChange={handleChange}
        className={classes.selectRoot}
        {...otherProps}
        inputProps={{
          name,
          id,
        }}
      >
        {children}
      </Select>
      {renderFromHelper({ touched, error })}
    </FormControl>
  );
};

SelectFormField.propTypes = propTypes;
SelectFormField.defaultProps = defaultProps;

renderFromHelper.propTypes = {
  touched: PropTypes.bool,
  error: PropTypes.string,
};

export default withStyles(styles)(SelectFormField);
